import React, { useCallback } from 'react';

import { Upgrade } from '@/components/AccountPanel/components/Upgrade';
import { PANEL_TRANSITION_TIMEOUT } from '@/config/constants';
import { useSubscription } from '@/providers/SubscriptionProvider';

import { Scrollbar } from '../Scrollbar';
import { AsaphDialogHeader, AsaphDialogHeaderButton } from '../shared/Dialog';
import AsaphDialog from '../shared/Dialog/AsaphDialog';
import styles from './PaidModal.module.scss';

export const PaidModal: React.FC = () => {
	const { paidModalOpen: open, setPaidModalOpen } = useSubscription();
	const handleClose = useCallback(() => {
		setPaidModalOpen(false);
	}, [setPaidModalOpen]);

	return (
		<AsaphDialog open={open} onClose={handleClose}>
			<div className={styles['paid-modal__toolbar']}>
				<AsaphDialogHeader
					leadingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: (
							<AsaphDialogHeaderButton
								type="text"
								label="Cancel"
								handlePress={handleClose}
							/>
						),
					}}
					title={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						label: 'Upgrade',
					}}
					trailingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: null,
					}}
				/>
			</div>
			<section className={styles['paid-modal__content']}>
				<Scrollbar
					className={styles['paid-modal__content-container']}
				>
					<Upgrade
						contentText="This content is exclusive to paid plans. Upgrade now for unlimited access."
						onClose={handleClose}
					/>
				</Scrollbar>
			</section>
		</AsaphDialog>
	);
};
